import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { DialogRef } from '../dialog-ref';
import { DialogCloseable } from '@components/dialog/dialog-closeable';

@Component({
    selector: 'oss-dialog-save-changes',
    templateUrl: './dialog-save-changes.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'c-dialog active c-dialog--sm c-dialog--gutter-xlg',
        '[class.c-dialog--icon]': 'config.icon && config.icon.length > 0'
    }
})
export class DialogSaveChangesComponent implements DialogCloseable {
    public config;
    public okButtonTitle: string;
    public isClosing: boolean = false;

    constructor(public dialogRef: DialogRef<DialogSaveChangesComponent>,
                public cdr: ChangeDetectorRef) {
        this.config = dialogRef.containerInstance.config;
        this.okButtonTitle = this.config.okButtonTitle || 'Common.Save';
    }

    /**
     * Process confirmed request and close.
     */
    process() {
        let result: boolean = true;
        this.isClosing = true;
        this.cdr.detectChanges();

        if (this.config.process) {
            // if the process returns a promise store it, else simply close it using `true`
            result = this.config.process() || true;
        }

        this.dialogRef.close(result);
    }

    /**
     * Updates the closing status.
     */
    onClose() {
        this.isClosing = true;
        this.cdr.detectChanges();
    }
}
